import type {
  SankeyLayoutLink,
  SankeyLayoutNode,
} from '../types/sankey-internal.js';

type LinkEndpoint = SankeyLayoutLink['source'];

/**
 * After the layout pass d3-sankey replaces the `source`/`target` ids with the
 * node objects themselves, but the vendored types still allow the id form.
 */
export const isResolvedNode = (
  endpoint: LinkEndpoint,
): endpoint is SankeyLayoutNode => typeof endpoint === 'object';
